import './Loading.css'

const Loading = ({ size = 'md', fullScreen = false, text }) => {
  const sizeClass = `loading-${size}`
  const classes = ['loading', sizeClass, fullScreen && 'loading-fullscreen']
    .filter(Boolean)
    .join(' ')

  if (fullScreen) {
    return (
      <div className="loading-fullscreen">
        <div className={classes}>
          <div className="loading-spinner"></div>
          {text && <p className="loading-text">{text}</p>}
        </div>
      </div>
    )
  }

  return (
    <div className={classes}>
      <div className="loading-spinner"></div>
      {text && <p className="loading-text">{text}</p>}
    </div>
  )
}

export default Loading

